import styled from '@emotion/styled';

import { forMobile, Tabs } from '@/design-system';
import { MOBILE_PAGE_PADDING } from '@/pages/portfolio/portfolio.styled';

export const OpportunitiesRoot = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 340px',
  alignItems: 'start',
  gap: theme.spacing[32],
  width: '100%',

  [forMobile]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
}));

export const OpportunitiesColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  gap: theme.spacing[40],

  [forMobile]: {
    gap: theme.spacing[32],
  },
}));

export const OpportunitiesSection = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  gap: theme.spacing[24],

  [forMobile]: {
    gap: theme.spacing[16],
  },
}));

export const SectionHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
}));

export const CuratedTabs = styled(Tabs.Root)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  gap: theme.spacing[24],

  [forMobile]: {
    gap: theme.spacing[16],
  },
}));

export const CuratedGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing[12],

  '& > *': { flexShrink: 0 },

  [forMobile]: {
    flexWrap: 'nowrap',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none',
    WebkitOverflowScrolling: 'touch',
    width: 'auto',
    marginInline: -MOBILE_PAGE_PADDING,
    paddingInline: MOBILE_PAGE_PADDING,
    scrollPaddingInline: MOBILE_PAGE_PADDING,

    '&::-webkit-scrollbar': { display: 'none' },

    '& > *': { scrollSnapAlign: 'start' },
  },
}));
